module.exports = __webpack_public_path__ + "img/IoTServe4_1.e24b48b5.png";